const initualState = {
  rcNo: "",
  companyName: "",
  yearinCorp: "",
  contactFullName: "",
  contactPhone: "",
  contactEmail: "",
  tin: ""
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "HANDLE_REQUEST_EMPLOYER_CHANGE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
